import * as React from "react"
import { useEditorState } from "@tiptap/react"
import { Button } from "../../tiptap-ui-primitive/button"
import { useTiptapEditor } from "../../hooks/use-tiptap-editor"

type TextAlign = "left" | "center" | "right" | "justify"

const ALIGN_ICONS: Record<TextAlign, string> = {
  left: "≡",
  center: "☰",
  right: "≡",
  justify: "☰",
}

export interface TextAlignButtonProps {
  align: TextAlign
}

export const TextAlignButton: React.FC<TextAlignButtonProps> = ({ align }) => {
  const editor = useTiptapEditor()

  const state = useEditorState({
    editor,
    selector: (ctx) => ({
      isActive: ctx.editor?.isActive({ textAlign: align }) ?? false,
    }),
  })

  const handleClick = () => {
    if (!editor) return
    editor.chain().focus().setTextAlign(align).run()
  }

  const ALIGN_LABELS: Record<TextAlign, string> = {
    left: "По левому краю",
    center: "По центру",
    right: "По правому краю",
    justify: "По ширине",
  }

  return (
    <Button
      onClick={handleClick}
      data-active={state.isActive}
      aria-label={ALIGN_LABELS[align]}
      title={ALIGN_LABELS[align]}
    >
      {ALIGN_ICONS[align]}
    </Button>
  )
}
